module.exports = __webpack_public_path__ + "img/638.f685b156.jpg";